import { useMemo } from "react";
import { useSelector } from "react-redux";
import { TableNames } from "../../../../enums/tableNames";
import { RootState } from "../../../../redux/store/store";

/**
 * Extracts and memoizes the active filter values relevant to the medical PA orders table
 * from the global Redux filter state.
 *
 * @returns Array of FilterValues matching the MEDICAL_PA_ORDERS_NEW table
 */
export const useValidFilters = () => {
  const { filters } = useSelector((state: RootState) => state.filterValues);

  const validFilters = useMemo(() => {
    return filters.filter(
      (filter) => filter.name === TableNames.MEDICAL_PA_ORDERS_NEW,
    );
  }, [filters]);

  return validFilters;
};
